import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setupChecklistUiIcons } from './setupChecklistData';

export default function SetupChecklistCompletedPills({ items, onToggle }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="ra-completed-row">
      {items.map((item) => (
        <button
          key={item.itemId}
          className="ra-pill"
          onClick={() => onToggle(item.itemId)}
          type="button"
        >
          <FontAwesomeIcon
            icon={setupChecklistUiIcons.check}
            className="ra-pill-check"
            aria-hidden="true"
          />
          <span>{item.title}</span>
        </button>
      ))}
    </div>
  );
}

SetupChecklistCompletedPills.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      itemId: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onToggle: PropTypes.func.isRequired,
};
